/**
 *
 * This function is in charge of the examples that are contained in the swagger specs
 * and create a JSON object that is then showed in an example section (either Response or Request)
 *
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function extractProperties(properties: { [key: string]: any }): {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
} {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result: { [key: string]: any } = {};
  for (const [key, value] of Object.entries(properties)) {
    if (value.type === 'object' && value.properties) {
      result[key] = extractProperties(value.properties);
    } else if (
      value.type === 'array' &&
      value.items &&
      value.items.properties
    ) {
      if (value.items.properties) {
        const examples = extractProperties(value.items.properties);
        if (Object.keys(examples).length > 0) {
          result[key] = [examples];
        }
      }
    } else if (value.example !== undefined) {
      result[key] = value.example;
    }
  }
  return result;
}
